<template>
    <div class="row">
        <div class="col-12 my-2">
            <div class="card-header-actions">

              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-6 card-header-search-box">
                    <div class="input-group">
                      <date-picker class="form-control"
                                   v-model="filter.date"
                                   format="dd/MM/yyyy"
                                   :placeholder="$t('common.date')"
                                   :clear-button="true"
                                   @cleared="initList"
                                   @selected="initList"
                      ></date-picker>
                      <div class="input-group-append">
                          <button class="all-btn search-btn" @click="initList">
                              <i class="fa fa-search"></i>
                          </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                    <div>
                      <v-select
                              v-model="filter.active"
                              :options="actions"
                              :filterable="false"
                              placeholder="Холатини танланг"
                              @change="initList"
                      >
                      </v-select>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_CAD_BUILDING_INDEX_ADD')" @click="showCadastreBuildingIndexEditModal(null,null)">{{$t("action.add")}}</button>
              </div>

            </div>
        </div>
        <div class="col-12 table-responsive mt-4">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>Сана</th>
                      <th>Коэффициент</th>
                      <th>Қурилиш тури</th>
                      <th>Вилоят</th>
                      <th>Туман</th>
                      <th>Холати</th>
                      <th class="text-center">Жараён</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                      <tr v-for="result in results.data" :key="result.id">
                          <td>{{result.date}}</td>
                          <td>{{result.coefficient | currency('', 3, { thousandsSeparator: ' ' })}}</td>
                          <td>
                              <span v-if="result.category === 'brick'">
                                  Пишган ғишт
                              </span>
                              <span v-else-if="result.category === 'panel'">
                                  Панел бетон
                              </span>
                          </td>
                          <td>
                              <span v-if="result.province">
                                  {{result.province.name}}
                              </span>
                          </td>
                          <td>
                              <span v-if="result.region">
                                   {{result.region.name}}
                              </span>
                          </td>
                          <td>
                              <span v-if="result.active">Актив</span>
                              <span v-else>Актив эмас</span>
                          </td>
                          <td class="td-actions text-center">
                              <button class="all-btn edit-btn table-action" data-original-title="Edit" @click="showCadastreBuildingIndexEditModal(result,false)">
                                  <i class="fa fa-edit"></i>
                              </button>
                              <button class="all-btn table-action" @click="showCadastreBuildingIndexEditModal(result,true)">
                                  <i class="fa fa-plus"></i>
                              </button>
                          </td>
                      </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <CadastreBuildingIndexModal />
    </div>
</template>

<script>
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import CadastreBuildingIndexModal from '@/views/config/cadastre/CadastreBuildingIndexEditModal'
    import DatePicker from 'vuejs-datepicker';

    export default {
        name: "CadastreBuildingIndexList",
        components: {
            'b-pagination': bPagination,
            CadastreBuildingIndexModal: CadastreBuildingIndexModal,
            DatePicker
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                actions: [
                    'ACTIVE',
                    'DEACTIVATED'
                ]
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('cadastre/building/index/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            showCadastreBuildingIndexEditModal(data,isNew) {
                let actionData = null;

                if (data) {
                    if (isNew) {
                        actionData = {
                            coefficient: null,
                            category: data.category,
                            province: data.province,
                            region: data.region,
                            active: true
                        };
                    } else actionData = data;
                }

                this.$eventBus.$emit('showCadastreBuildingIndexModal',actionData)
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('cadastreBuildingIndexChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>